import React, {
  useEffect, useState, useContext, useRef,
} from 'react';
import { useHistory } from 'react-router-dom';
import service4w from '../../services/service4w';
import SegmentacionPage4w from '../../pages/MaestrosPage/SegmentationPage4w/SegmentationPage4w';
import filterArray from '../../utils/filterArray';
import { Context } from '../../context/Contex';

const initialState = 'pickup';

const Segmentation4w = () => {
  const [show, setShow] = useState(false);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [option, setOption] = useState(initialState);
  const [pickup, setPickup] = useState([]);
  const [selector, setSelector] = useState([]);
  const history = useHistory();
  const { permisos } = useContext(Context);

  const dataTable = [];
  const timerToClearSomewhere = useRef(null);

  useEffect(() => {
    timerToClearSomewhere.current = setInterval(() => setUpdate(false), 5000);
    return () => {
      clearInterval(timerToClearSomewhere.current);
    };
  }, []);

  /*= =======================================================================
  Get Segmentación
========================================================================= */
  const getService = () => {
    setLoading(true);
    service4w.get4w(option)
      .then((response) => {
        setPickup(response.data.datos);
        setLoading(false);
      })
      .catch((error) => {
        history.push('/home');
        setLoading(false);
        console.log(error);
      });
  };
  /*= =======================================================================
  Get getMarcaLinea
========================================================================= */
  const getMarcaLinea = () => {
    setLoading(!loading);
    service4w.getSelector()
      .then((response) => {
        setSelector(response.data.datos);
        setLoading(false);
      })
      .catch((error) => {
        history.push('/home');
        setLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    getService();
  }, [option]);

  /*= ========================================================================
  Get create ColumnsTable
========================================================================= */
  if (pickup) {
    try {
      pickup.forEach((value) => {
        dataTable.push({
          uuid: value.UUID,
          marca: value.MARCA,
          linea: value.LINEA,
        });
      });
    } catch (err) {
      console.log(err);
    }
  }

  /*= ========================================================================
  Get  delete pickUp
========================================================================= */
  const handleDelete = (event) => {
    setLoading(true);
    service4w.delete4w(event.rowData, option)
      .then(() => {
        setLoading(false);
        getService();
      });
  };
  /*= ========================================================================
  Get  create handleCreate
========================================================================= */
  const handleCreate = (item) => () => {
    setLoading(true);
    service4w.post4w(item, option)
      .then((response) => {
        if (response.data.id) {
          getService();
        } else {
          setUpdate(true);
          setLoading(false);
        }
      });
  };

  /*= ========================================================================
  Get  delete handleSearch
========================================================================= */
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const handleClick = () => {
    setShow(!show);
    if (!show) {
      getMarcaLinea();
    }
  };

  const handleSelect = (value) => {
    setShow(false);
    setOption(value);
  };

  const filteredSelector = filterArray(selector, 'MARCA', search);

  return (
    <>
      <SegmentacionPage4w
        show={show}
        option={option}
        update={update}
        loading={loading}
        pickup={dataTable}
        permits={permisos}
        selector={filteredSelector}
        search={search}
        handleSelect={handleSelect}
        handleDelete={handleDelete}
        hanleCreate={handleCreate}
        handleCreate={handleCreate}
        handleSearch={handleSearch}
        handleClick={handleClick}
      />
    </>

  );
};

export default Segmentation4w;
